import { render, staticRenderFns } from "./common-tabs.vue?vue&type=template&id=1aa4b6c2&scoped=true&"
import script from "./common-tabs.vue?vue&type=script&lang=js&"
export * from "./common-tabs.vue?vue&type=script&lang=js&"
import style0 from "./common-tabs.vue?vue&type=style&index=0&id=1aa4b6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4b6c2",
  null
  
)

export default component.exports